function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/observer/bubblingemittermixin
 */
import EventInfo from '@ckeditor/ckeditor5-utils/src/eventinfo';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import EmitterMixin from '@ckeditor/ckeditor5-utils/src/emittermixin';
import toArray from '@ckeditor/ckeditor5-utils/src/toarray';
import BubblingEventInfo from './bubblingeventinfo';
var contextsSymbol = Symbol('bubbling contexts');
/**
 * Bubbling emitter mixin for the view document as described in the
 * {@link ~BubblingEmitter} interface.
 *
 * @mixin BubblingEmitterMixin
 * @implements module:engine/view/observer/bubblingemittermixin~BubblingEmitter
 */

var BubblingEmitterMixin = {
  /**
   * @inheritDoc
   */
  fire: function fire(eventOrInfo) {
    try {
      var eventInfo = eventOrInfo instanceof EventInfo ? eventOrInfo : new EventInfo(this, eventOrInfo);
      var eventContexts = getBubblingContexts(this);

      if (!eventContexts.size) {
        return;
      }

      updateEventInfo(eventInfo, 'capturing', this); // The capture phase of the event.

      for (var _len = arguments.length, eventArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        eventArgs[_key - 1] = arguments[_key];
      }

      if (fireListenerFor.apply(void 0, [eventContexts, '$capture', eventInfo].concat(eventArgs))) {
        return eventInfo.return;
      }

      var startRange = eventInfo.startRange || this.selection.getFirstRange();
      var selectedElement = startRange ? startRange.getContainedElement() : null;
      var isCustomContext = selectedElement ? Boolean(getCustomContext(eventContexts, selectedElement)) : false;
      var node = selectedElement || getDeeperRangeParent(startRange);
      updateEventInfo(eventInfo, 'atTarget', node); // For the not yet bubbling event trigger for $text node if selection can be there and it's not a custom context selected.

      if (!isCustomContext) {
        if (fireListenerFor.apply(void 0, [eventContexts, '$text', eventInfo].concat(eventArgs))) {
          return eventInfo.return;
        }

        updateEventInfo(eventInfo, 'bubbling', node);
      }

      while (node) {
        // Root node handling.
        if (node.is('rootElement')) {
          if (fireListenerFor.apply(void 0, [eventContexts, '$root', eventInfo].concat(eventArgs))) {
            return eventInfo.return;
          }
        } // Element node handling.
        else if (node.is('element')) {
            if (fireListenerFor.apply(void 0, [eventContexts, node.name, eventInfo].concat(eventArgs))) {
              return eventInfo.return;
            }
          } // Check custom contexts (i.e., a widget).


        if (fireListenerFor.apply(void 0, [eventContexts, node, eventInfo].concat(eventArgs))) {
          return eventInfo.return;
        }

        node = node.parent;
        updateEventInfo(eventInfo, 'bubbling', node);
      }

      updateEventInfo(eventInfo, 'bubbling', this); // Document context.

      fireListenerFor.apply(void 0, [eventContexts, '$document', eventInfo].concat(eventArgs));
      return eventInfo.return;
    } catch (err) {
      // @if CK_DEBUG // throw err;

      /* istanbul ignore next */
      CKEditorError.rethrowUnexpectedError(err, this);
    }
  },

  /**
   * @inheritDoc
   */
  _addEventListener: function _addEventListener(event, callback, options) {
    var contexts = toArray(options.context || '$document');
    var eventContexts = getBubblingContexts(this);

    var _iterator = _createForOfIteratorHelper(contexts),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var context = _step.value;
        var emitter = eventContexts.get(context);

        if (!emitter) {
          emitter = Object.create(EmitterMixin);
          eventContexts.set(context, emitter);
        }

        this.listenTo(emitter, event, callback, options);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },

  /**
   * @inheritDoc
   */
  _removeEventListener: function _removeEventListener(event, callback) {
    var eventContexts = getBubblingContexts(this);

    var _iterator2 = _createForOfIteratorHelper(eventContexts.values()),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var emitter = _step2.value;
        this.stopListening(emitter, event, callback);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
};
export default BubblingEmitterMixin; // Update the event info bubbling fields.
//
// @param {module:utils/eventinfo~EventInfo} eventInfo The event info object to update.
// @param {'none'|'capturing'|'atTarget'|'bubbling'} eventPhase The current event phase.
// @param {module:engine/view/document~Document|module:engine/view/node~Node} currentTarget The current bubbling target.

function updateEventInfo(eventInfo, eventPhase, currentTarget) {
  if (eventInfo instanceof BubblingEventInfo) {
    eventInfo._eventPhase = eventPhase;
    eventInfo._currentTarget = currentTarget;
  }
} // Fires the listener for the specified context. Returns `true` if event was stopped.
//
// @private
// @param {Map.<String|Function, module:utils/emittermixin~Emitter>} eventContexts
// @param {String|module:engine/view/node~Node} context
// @param {module:utils/eventinfo~EventInfo} eventInfo The `EventInfo` object.
// @param {...*} [eventArgs] Additional arguments to be passed to the callbacks.
// @returns {Boolean} True if event stop was called.


function fireListenerFor(eventContexts, context, eventInfo) {
  var emitter = typeof context == 'string' ? eventContexts.get(context) : getCustomContext(eventContexts, context);

  if (!emitter) {
    return false;
  }

  for (var _len2 = arguments.length, eventArgs = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    eventArgs[_key2 - 3] = arguments[_key2];
  }

  emitter.fire.apply(emitter, [eventInfo].concat(eventArgs));
  return eventInfo.stop.called;
} // Returns an emitter for a specified view node.
//
// @private
// @param {Map.<String|Function, module:utils/emittermixin~Emitter>} eventContexts
// @param {module:engine/view/node~Node} node
// @returns {module:utils/emittermixin~Emitter|null}


function getCustomContext(eventContexts, node) {
  var _iterator3 = _createForOfIteratorHelper(eventContexts),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _ref3 = _step3.value;

      var _ref2 = _slicedToArray(_ref3, 2);

      var context = _ref2[0];
      var emitter = _ref2[1];

      if (typeof context == 'function' && context(node)) {
        return emitter;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return null;
} // Returns bubbling contexts map for the source (emitter).


function getBubblingContexts(source) {
  if (!source[contextsSymbol]) {
    source[contextsSymbol] = new Map();
  }

  return source[contextsSymbol];
} // Returns the deeper parent element for the range.


function getDeeperRangeParent(range) {
  if (!range) {
    return null;
  }

  var startParent = range.start.parent;
  var endParent = range.end.parent;
  var startPath = startParent.getPath();
  var endPath = endParent.getPath();
  return startPath.length > endPath.length ? startParent : endParent;
}
/**
 * Bubbling emitter for the view document.
 *
 * Bubbling emitter is triggering events in the context of specified {@link module:engine/view/element~Element view element} name,
 * predefined `'$text'`, `'$root'`, `'$document'` and `'$capture'` contexts, and context matchers provided as a function.
 *
 * Before bubbling starts, listeners for `'$capture'` context are triggered. Then the bubbling starts from the deeper selection
 * position (by firing event on the `'$text'` context) and propagates the view document tree up to the `'$root'` and finally
 * the listeners at `'$document'` context are fired (this is the default context).
 *
 * Examples:
 *
 *		// Listeners registered in the context of the view element names:
 *		this.listenTo( viewDocument, 'enter', ( evt, data ) => {
 *			// ...
 *		}, { context: 'blockquote' } );
 *
 *		this.listenTo( viewDocument, 'enter', ( evt, data ) => {
 *			// ...
 *		}, { context: 'li' } );
 *
 *		// Listeners registered in the context of the '$text' and '$root' nodes.
 *		this.listenTo( view.document, 'arrowKey', ( evt, data ) => {
 *			// ...
 *		}, { context: '$text', priority: 'high' } );
 *
 *		this.listenTo( view.document, 'arrowKey', ( evt, data ) => {
 *			// ...
 *		}, { context: '$root' } );
 *
 *		// Listeners registered in the context of custom callback function.
 *		this.listenTo( view.document, 'arrowKey', ( evt, data ) => {
 *			// ...
 *		}, { context: isWidget } );
 *
 *		this.listenTo( view.document, 'arrowKey', ( evt, data ) => {
 *			// ...
 *		}, { context: isWidget, priority: 'high' } );
 *
 * Example flow for selection in text:
 *
 *		<blockquote><p>Foo[]bar</p></blockquote>
 *
 * Fired events on contexts:
 * 1. `'$capture'`
 * 2. `'$text'`
 * 3. `'p'`
 * 4. `'blockquote'`
 * 5. `'$root'`
 * 6. `'$document'`
 *
 * Example flow for selection on element (i.e., Widget):
 *
 *		<blockquote><p>Foo[<widget/>]bar</p></blockquote>
 *
 * Fired events on contexts:
 * 1. `'$capture'`
 * 2. *widget* (custom matcher)
 * 3. `'p'`
 * 4. `'blockquote'`
 * 5. `'$root'`
 * 6. `'$document'`
 *
 * There could be multiple listeners registered for the same context and at different priority levels:
 *
 *		<p>Foo[]bar</p>
 *
 * 1. `'$capture'` at priorities:
 *    1. `'highest'`
 *    2. `'high'`
 *    3. `'normal'`
 *    4. `'low'`
 *    5. `'lowest'`
 * 2. `'$text'` at priorities:
 *    1. `'highest'`
 *    2. `'high'`
 *    3. `'normal'`
 *    4. `'low'`
 *    5. `'lowest'`
 * 3. `'p'` at priorities:
 *    1. `'highest'`
 *    2. `'high'`
 *    3. `'normal'`
 *    4. `'low'`
 *    5. `'lowest'`
 * 4. `'$root'` at priorities:
 *    1. `'highest'`
 *    2. `'high'`
 *    3. `'normal'`
 *    4. `'low'`
 *    5. `'lowest'`
 * 5. `'$document'` at priorities:
 *    1. `'highest'`
 *    2. `'high'`
 *    3. `'normal'`
 *    4. `'low'`
 *    5. `'lowest'`
 *
 * @interface BubblingEmitter
 * @extends module:utils/emittermixin~Emitter
 */